var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FormWrapper",
    { attrs: { title: "Resume", body: "Upload your Resume" } },
    [
      _c("div", { staticClass: "mt-4 flex flex-wrap md:mt-0" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.filename,
                expression: "filename",
              },
            ],
            staticClass:
              "border rounded-sm flex flex-grow items-center px-4 py-2 mb-4",
          },
          [
            _c("FileIcon", {
              staticClass: "flex-shrink-0 mr-1.5 h-8 w-8 text-gray-400",
            }),
            _c("span", { staticClass: "text-xs text-gray-500" }, [
              _vm._v(" " + _vm._s(_vm.filename) + " "),
            ]),
          ],
          1
        ),
        _c("div", { staticClass: "ml-auto flex space-x-4" }, [
          _c("input", {
            ref: "fileUpload",
            attrs: { type: "file", hidden: "" },
            on: { change: _vm.changeFiles },
          }),
          _c(
            "div",
            { staticClass: "mx-2" },
            [
              _c("UiButton", {
                attrs: {
                  variant: "outline",
                  buttonText: "Delete",
                  processing: _vm.$apollo.queries.resume.loading,
                  disabled: !Boolean(_vm.resume),
                },
                on: { click: _vm.handleRemoveFile },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mx-2" },
            [
              _c("UiButton", {
                attrs: {
                  buttonText: "Upload",
                  variant: "black",
                  processing: _vm.$apollo.queries.resume.loading,
                },
                on: { click: _vm.handleFileUpload },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }